import { useEffect, useState } from 'react';
import { runRecurringBilling, type RecurringBillingResult } from '@/lib/recurringBilling';

// Ejecuta la generación automática de facturas recurrentes una sola vez al
// montar la página. Devuelve el resultado (creadas/omitidas/errores) para que
// la UI pueda refrescar los datos o mostrar una notificación.
export function useRecurringBilling(): RecurringBillingResult | null {
  const [result, setResult] = useState<RecurringBillingResult | null>(null);

  useEffect(() => {
    let active = true;
    runRecurringBilling().then((res) => {
      if (active) setResult(res);
    });
    return () => {
      active = false;
    };
  }, []);

  return result;
}